import React, { Component } from "react";
import { BreadCrumb } from "primereact/breadcrumb";
import { Link } from "react-router-dom";
import moment from "moment";
import swal from "sweetalert";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { authenticationService } from "../../_services";
import { serviceKeywordService } from "../../_services/admin/servicesKeywords.service";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilAlt, faTrash } from "@fortawesome/free-solid-svg-icons";
export default class ServicesKeyword extends Component {
  constructor(props) {
    super();
    this.state = {
      currentUser: authenticationService.currentUserValue,
      serviceKeywordData: [],
      serviceKeywordGlobalFilter: null
    };
  }

  componentDidMount() {
    this.getAllServiceKeyword();
  }

  getAllServiceKeyword = () => {
    serviceKeywordService.getAllServiceKeyword().then((data) => {
      if (data) {
        this.setState({ serviceKeywordData: data.Data });
      }
    });
  };

  deleteServiceKeywordById = (serviceKeywordId) => {
    let requestData = {
      serviceKeywordId,
      currentUserId: this.state.currentUser.id
    };
    serviceKeywordService.deleteServiceKeywordById(requestData).then((data) => {
      if (data) {
        this.getAllServiceKeyword();
        swal("Service Keyword Delete Successfully", " ", "success");
      }
    });
  };

  actionTemplate = (rowData) => {
    return (
      <div className="action-container">
        <span
          className="cursor-pointer text-primary"
          data-toggle="tooltip"
          title="Edit"
        >
          <Link to={`/servicesKeyword/edit/${rowData._id}`}>
            <FontAwesomeIcon icon={faPencilAlt} />
          </Link>
        </span>

        <span
          className="cursor-pointer text-danger"
          data-toggle="tooltip"
          title="delete"
          onClick={(e) => this.deleteServiceKeywordById(rowData._id)}
        >
          <FontAwesomeIcon icon={faTrash} />
        </span>
      </div>
    );
  };

  dateTemplate = (rowData) => {
    return moment(rowData.updatedAt).format("MM/DD/YYYY hh:mm a");
  };

  render() {
    const items = [
      { label: "Management" },
      {
        label: "Service/Keywords"
      }
    ];
    const home = { icon: "pi pi-home", url: "/aboutus" };

    return (
      <>
        <BreadCrumb model={items} home={home} className="mb-3" />

        <div className="p-grid">
          <div className="p-col-12">
            <div className="datatable-filter">
              <div className="card">
                <div className="text-right mb-2">
                  <Link to="/servicesKeyword/add" className="btn btn-primary">
                    Add New Service/Keyword
                  </Link>
                </div>
                <div className="mb-3 table-header">
                  <h2>List of Service Keyword</h2>
                  <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText
                      type="search"
                      onInput={(e) =>
                        this.setState({
                          serviceKeywordGlobalFilter: e.target.value
                        })
                      }
                      placeholder="Search"
                    />
                  </span>
                </div>
                <div className="custom-table-responsive ">
                  <DataTable
                    value={this.state.serviceKeywordData}
                    className="p-datatable-striped"
                    paginator
                    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                    rows={10}
                    globalFilter={this.state.serviceKeywordGlobalFilter}
                    rowsPerPageOptions={[10, 20, 50]}
                  >
                    <Column
                      field="serviceKeyword"
                      header="Service Keyword"
                      sortable
                    ></Column>
                    <Column
                      field="updatedAt"
                      header="Modified At"
                      sortable
                      body={this.dateTemplate}
                    ></Column>
                    <Column
                      body={this.actionTemplate}
                      header="Action"
                      className="text-center"
                    ></Column>
                  </DataTable>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
